import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    date: String
  }

  static targets = ["days", "hours", "minutes", "seconds"]

  connect() {
    this.targetDate = new Date(this.dateValue)
    this.update()
    this.interval = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  update() {
    const now = new Date()
    const diff = this.targetDate - now

    if (diff <= 0) {
      this.element.innerHTML = '<span class="text-lime-600 font-semibold">Event is happening now!</span>'
      clearInterval(this.interval)
      return
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    if (this.hasDaysTarget) this.daysTarget.textContent = days
    if (this.hasHoursTarget) this.hoursTarget.textContent = hours.toString().padStart(2, '0')
    if (this.hasMinutesTarget) this.minutesTarget.textContent = minutes.toString().padStart(2, '0')
    if (this.hasSecondsTarget) this.secondsTarget.textContent = seconds.toString().padStart(2, '0')
  }
}
